import { useMutation } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast, ErrorToast } from 'services/toasterService';

export default function UseResendOtp() {
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(apiEndPoints.SENDOTP, data);
      return response.data;
    },
    {
      onSuccess: (data) => {
        SuccessToast({ text: data.message });
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
